import { createContext } from "react";
import {
  type FormAction,
  type ValidFormField,
} from "src/components/Form/Form.types.ts";
import type {
  DisabledField,
  HiddenField,
  ValidFormLayoutConfig,
} from "src/system/module.types.ts";
import type { FieldValues } from "react-hook-form";

export type ResourceFormContextValue<
  FormValues extends FieldValues = FieldValues,
> = {
  resource: string;
  lang: string;
  action: FormAction;
  includes: string[] | undefined;
  locale: string;
  meta?: any;
  onSubmit: (values: FormValues) => void;
  onSubmitWithParams: (params: {
    onSuccess?: () => void;
    onError?: (error: any) => void;
  }) => (values: FormValues) => void;
  availableLocales: string[];
  tab?: string;
  layoutConfig: ValidFormLayoutConfig<FormValues>;
  id: string | undefined;
  fields: Record<string, ValidFormField<FormValues>>;
  hidden_fields?: {
    [Path in keyof FormValues]?: HiddenField<FormValues>;
  };
  disabled_fields?: {
    [Path in keyof FormValues]?: DisabledField<FormValues>;
  };
};

export const ResourceFormContext =
  createContext<ResourceFormContextValue<any> | null>(null);
